import { type AppetizeOSVersions } from "../utils/types";

const iosDevices = [
  "iphone15promax",
  "iphone15pro",
  "iphone14promax",
  "iphone14pro",
  "iphone13pro",
  "iphone13promax",
  "iphone12mini",
  "iphone8",
  "ipadair2",
  "ipadair4thgeneration",
  "ipad9thgeneration",
  "ipadpro129inch5thgeneration",
  "ipadmini6thgeneration",
];

const androidDevices = [
  "pixel7",
  "nexus5",
  "nexus7",
  "nexus9",
  "pixel4",
  "pixel4xl",
  "pixel6pro",
  "galaxytabs7",
];

const kIosOsName = "iOS";
const kAndroidOsName = "Android";

// TODO get it from firestore
const kLanguages = [
  "ar_EG", // Arabic (Egypt)
  "ar_SA", // Arabic (Saudi Arabia)
  "bn_IN", // Bengali (India)
  "cs_CZ", // Czech (Czech Republic)
  "da_DK", // Danish (Denmark)
  "de_DE", // German (Germany)
  "el_GR", // Greek (Greece)
  "en_CA", // English (Canada)
  "en_GB", // English (United Kingdom)
  "en_US", // English (United States)
  "es_ES", // Spanish (Spain)
  "es_AR", // Spanish (Argentina)
  "fr_FR", // French (France)
  "hi_IN", // Hindi (India)
  "hu_HU", // Hungarian (Hungary)
  "id_ID", // Indonesian (Indonesia)
  "it_IT", // Italian (Italy)
  "ja_JP", // Japanese (Japan)
  "ko_KR", // Korean (South Korea)
  "nl_NL", // Dutch (Netherlands)
  "pl_PL", // Polish (Poland)
  "pt_PT", // Portuguese (Portugal)
  "ro_RO", // Romanian (Romania)
  "ru_RU", // Russian (Russia)
  "sv_SE", // Swedish (Sweden)
  "ta_SG", // Tamil (Singapore)
  "te_IN", // Telugu (India)
  "th_TH", // Thai (Thailand)
  "tl_PH", // Tagalog (Philippines)
  "tr_TR", // Turkish (Turkey)
  "uk_UA", // Ukrainian (Ukraine)
  "vi_VN", // Vietnamese (Vietnam)
  "zh_CN", // Chinese Simplified (China)
  "he_IL",
  "fi_FI",
  "no_NO",
  "fr_CA",
  "pt_BR",
  "es_419",
  "es_MX",
  "es_US",
  "zh_TW",
  "zh_HK",
  "ar",
];

const kOrientations = ["portrait", "landscape"];

const kDelayAtSessionStartTime = 15000;
const kEditorDelayAtSessionStartTime = 7000;

const kDefaultAppetizeOSVersions: AppetizeOSVersions = {
  ios: {
    iphone8: ["15.5", "16.2"],
    iphone8plus: ["15.5", "16.2"],
    iphone11pro: ["15.5", "16.2", "17.2", "18.0"],
    iphone12: ["15.5", "16.2", "17.2", "18.0"],
    iphone13pro: ["15.5", "16.2", "17.2", "18.0"],
    iphone13promax: ["15.5", "16.2", "17.2", "18.0"],
    iphone14pro: ["16.2", "17.2", "18.0"],
    iphone14promax: ["16.2", "17.2", "18.0"],
    iphone15pro: ["17.2", "18.0"],
    iphone15promax: ["17.2", "18.0"],
    iphone16pro: ["18.0"],
    iphone16promax: ["18.0"],
    ipadair4thgeneration: ["15.5", "16.2", "17.2", "18.0"],
    ipadpro129inch5thgeneration: ["15.5", "16.2", "17.2", "18.0"],
    ipad9thgeneration: ["15.5", "16.2", "17.2"],
    ipadmini6thgeneration: ["18.0"],
  },
  android: {
    nexus5: ["8.1", "9.0", "10.0", "11.0"],
    pixel4: ["10.0", "11.0", "12.0"],
    pixel4xl: ["10.0", "11.0", "12.0"],
    pixel6: ["12.0", "13.0", "14.0"],
    pixel6pro: ["12.0", "13.0", "14.0"],
    pixel7: ["13.0", "14.0"],
    pixel7pro: ["13.0", "14.0"],
    pixel8: ["14.0"],
    pixel8pro: ["14.0"],
    galaxytabs7: ["10.0", "11.0", "12.0", "13.0"],
  },
};

const browserStackDevices: AppetizeOSVersions = {
  ios: {
    "iPhone 15 Pro Max": ["17", "26"],
    "iPhone 15": ["17", "26"],
    "iPhone 15 Pro": ["17"],
    "iPhone 15 Plus": ["17"],
    "iPhone 14 Pro": ["16", "26"],
    "iPhone 14": ["16", "18", "26"],
    "iPhone 13 Pro Max": ["18"],
    "iPhone 13": ["16", "17", "18"],
    "iPhone 12 Pro": ["17", "18"],
    "iPhone 12": ["17"],
    "iPhone 14 Pro Max": ["16"],
    "iPhone 14 Plus": ["16"],
    "iPhone 12 Pro Max": ["16"],
    "iPhone 13 Pro": ["15"],
    "iPhone 13 Mini": ["15"],
    "iPhone 11": ["13"],
    "iPhone 7": ["10"],
    "iPhone Air": ["26"],
    "iPhone 17 Pro Max": ["26"],
    "iPhone 17 Pro": ["26"],
    "iPhone 17": ["26"],
    "iPhone 16e": ["18"],
    "iPhone 16 Pro Max": ["18"],
    "iPhone 16 Pro": ["18"],
    "iPhone 16 Plus": ["18"],
    "iPhone 16": ["18"],
    "iPhone SE 2020": ["16"],
    "iPhone SE 2022": ["15"],
    "iPad Air 4": ["14"],
    "iPad 9th": ["15", "18"],
    "iPad Pro 13 2025": ["26"],
    "iPad Pro 11 2025": ["26"],
    "iPad Air 5": ["26"],
    "iPad Pro 11 2021": ["18"],
    "iPad Pro 13 2024": ["17"],
    "iPad Pro 12.9 2021": ["14", "17"],
    "iPad Pro 11 2024": ["17"],
    "iPad Air 6": ["17"],
    "iPad Pro 12.9 2022": ["16"],
    "iPad Pro 12.9 2020": ["14", "16"],
    "iPad Pro 11 2022": ["16"],
    "iPad 10th": ["16"],
    "iPad Air 13 2025": ["18", "26"],
    "iPad Pro 11 2020": ["13", "16"],
    "iPad 8th": ["14", "16"],
    "iPad Mini 2021": ["15"],
    "iPad 6th": ["11"],
  },
  android: {
    "Samsung Galaxy S23 Ultra": ["13.0"],
    "Samsung Galaxy S23": ["13.0"],
    "Samsung Galaxy S22 Ultra": ["12.0"],
    "Samsung Galaxy S22 Plus": ["12.0"],
    "Samsung Galaxy S22": ["12.0"],
    "Samsung Galaxy S21": ["11.0", "12.0"],
    "Samsung Galaxy S21 Ultra": ["11.0"],
    "Samsung Galaxy S21 Plus": ["11.0"],
    "Samsung Galaxy S20": ["10.0"],
    "Samsung Galaxy S20 Ultra": ["10.0"],
    "Samsung Galaxy S25 Ultra": ["15.0"],
    "Samsung Galaxy S25": ["15.0"],
    "Samsung Galaxy S24 Ultra": ["14.0"],
    "Samsung Galaxy S24": ["14.0"],
    "Samsung Galaxy M52": ["11.0"],
    "Samsung Galaxy M32": ["11.0"],
    "Samsung Galaxy A52": ["11.0"],
    "Samsung Galaxy Note 20": ["10.0"],
    "Samsung Galaxy A51": ["10.0"],
    "Samsung Galaxy A11": ["10.0"],
    "Samsung Galaxy S10": ["9.0"],
    "Samsung Galaxy A10": ["9.0"],
    "Samsung Galaxy Note 9": ["8.1"],
    "Google Pixel 9": ["15.0", "16.0"],
    "Google Pixel 10 Pro XL": ["16.0"],
    "Google Pixel 10 Pro": ["16.0"],
    "Google Pixel 10": ["16.0"],
    "Google Pixel 9 Pro XL": ["15.0"],
    "Google Pixel 9 Pro": ["15.0"],
    "Google Pixel 6 Pro": ["13.0", "15.0"],
    "Google Pixel 8 Pro": ["14.0"],
    "Google Pixel 8": ["14.0"],
    "Google Pixel 7 Pro": ["13.0"],
    "Google Pixel 7": ["13.0"],
    "Google Pixel 6": ["12.0"],
    "Google Pixel 5": ["11.0"],
    "OnePlus 13R": ["15.0"],
    "OnePlus 12R": ["14.0"],
    "OnePlus 11R": ["13.0"],
    "OnePlus 9": ["11.0"],
    "OnePlus 8": ["10.0"],
    "Vivo Y21": ["11.0"],
    "Vivo V21": ["11.0"],
    "Vivo Y50": ["10.0"],
    "Oppo Reno 6": ["11.0"],
    "Oppo A96": ["11.0"],
    "Oppo Reno 3 Pro": ["10.0"],
    "Xiaomi Redmi Note 11": ["11.0"],
    "Xiaomi Redmi Note 9": ["10.0"],
    "Motorola Moto G71 5G": ["11.0"],
    "Motorola Moto G9 Play": ["10.0"],
    "Huawei Nova 11 SE": ["12.0"],
    "Huawei P30": ["9.0"],
    "Samsung Galaxy Tab S11": ["16.0"],
    "Samsung Galaxy Tab S10 Plus": ["15.0"],
    "Samsung Galaxy Tab A9 Plus": ["14.0"],
    "Samsung Galaxy Tab S9": ["13.0"],
    "Samsung Galaxy Tab S8": ["12.0"],
    "Samsung Galaxy Tab S7": ["10.0", "11.0"],
  },
};

export {
  iosDevices,
  androidDevices,
  kIosOsName,
  kAndroidOsName,
  kLanguages,
  kDelayAtSessionStartTime,
  kDefaultAppetizeOSVersions,
  kOrientations,
  kEditorDelayAtSessionStartTime,
  browserStackDevices,
};
